import $ from 'jquery';

const MAPA = {
  numero: 'codigo',
  projeto: 'idProjeto',
  situacao: 'mostrarSolicitacoes',
  beneficiario: 'beneficiario',
  solicitacaoWeb: 'solicitacaoWeb',
};

function expandirFiltros(query) {
  $('.ibox').removeClass('collapsed');

  if (query.projeto && $('#projeto').length)
    $('#projeto').val('' + query.projeto).trigger('change.select2');
}

export function aplicarFiltrosDaQuery(vm, filtros, query) {
  const q = query || {};
  let aplicou = false;

  Object.keys(MAPA).forEach(chave => {
    const campo = MAPA[chave];

    if (q[chave] === undefined || q[chave] === '' || !(campo in filtros)) return;

    filtros[campo] = typeof filtros[campo] === 'number' ? +q[chave] : '' + q[chave];
    aplicou = true;
  });

  if (!aplicou) return false;

  if ('filtrado' in filtros) filtros.filtrado = true;
  if ('filtrar' in filtros) filtros.filtrar = true;
  if ('periodo' in filtros && (q.numero || q.solicitacaoWeb)) filtros.periodo = '';

  if (vm) {
    vm.$nextTick(() => expandirFiltros(q));
    setTimeout(() => expandirFiltros(q), 1200);
  }

  return true;
}

export default { aplicarFiltrosDaQuery };



// WEBPACK FOOTER //
// ./FrontEnd/js/filtros-por-query.js